
import React, { useState, useEffect } from 'react';
import tapIcon from '../../../services/TapIcon';
import Ax from "../../../components/hoc/Ax";
import { connect, useSelector } from 'react-redux';
import Loader from "../../../components/ui/Loader/Loader";
import AppBaseComponent from "../../../components/AppBaseComponent";
import HttpAPICall from "../../../services/HttpAPICall";
import ApplicationLayout from '../../../layouts/ApplicationLayout';
import { Helmet } from 'react-helmet';
import { BACKOFFICE_BASE_URL } from '../../../services/TapApiUrls';
import { toast } from 'react-toastify';

const ManufacturerAdd = ({ history, location }) => {
    const initAddManufacturerForm = {
        name: '',
        nick_name: '',
        notes: ''
    };
    const manufacturerAddUrl    =  BACKOFFICE_BASE_URL + '/manufacturer/add'
    const manufacturerEditUrl   =  BACKOFFICE_BASE_URL + '/manufacturer/edit'

    const [saveFormSubmitting, setSaveFormSubmitting] = useState(false);
    const [addManufacturerForm, setAddManufacturerForm] = useState({ ...initAddManufacturerForm });
    const [formLoading, setFormLoading] = useState(false);
    const [editResource, setEditResource] = useState(false);
    const access_token = useSelector(state => state.auth.access_token);
    useEffect(() => {
        getAddFormData()
    }, []);

    const closeEvent = () => {
        history.push({ pathname: `/manufacturer_list` });
    };
    const getAddFormData = () => {
        setFormLoading(true);
        if (location.state && location.state.editManufacturerData) {
            let detail = location.state.editManufacturerData;
            setAddManufacturerForm({
                ...initAddManufacturerForm,
                id: detail.id,
                name: detail.manufacturer,
                nick_name: detail.mnf_nick_name,
                notes: detail.description ? detail.description : "",
            });
            setEditResource(true);
        }
        setFormLoading(false);
    };

    const submitAddManufacturerForm = (e) => {
        e.preventDefault();
        const formData = {
            ...addManufacturerForm,
        };
        if (editResource) {
            setSaveFormSubmitting(true);
            HttpAPICall.withAthorization('PUT', manufacturerEditUrl, access_token, {}, { ...formData }, (resp) => {
                toast.success(resp.data.msg, { position: toast.POSITION.TOP_RIGHT });
                setAddManufacturerForm({ ...initAddManufacturerForm });
                history.push({ pathname: `/manufacturer_list` })
            }).then(() => setSaveFormSubmitting(false));
        } else {
            setSaveFormSubmitting(true);
            HttpAPICall.withAthorization('POST', manufacturerAddUrl, access_token, {}, { ...formData }, (resp) => {
                toast.success(resp.data.msg, { position: toast.POSITION.TOP_RIGHT });
                setAddManufacturerForm({ ...initAddManufacturerForm });
                history.push({ pathname: `/manufacturer_list` })
            }).then(() => setSaveFormSubmitting(false));
        }

    };

    const formInputHandler = (e, formName) => {
        const { name, value } = e.target;
        if (formName === "addManufacturerForm") {
            setAddManufacturerForm(prevState => ({ ...prevState, [name]: value }));
        }
    };

    const saveManufacturerFormJsx = () => {
        return (
            <form className="bg-white p-3" onSubmit={submitAddManufacturerForm} id="saveResourceForm">
                {formLoading ? <Loader />
                    : <Ax>
                        <div className="row align-items-center my-3">
                            <div className="col-sm-3">
                                <label htmlFor="name" className="form-label require">Name</label>
                            </div>
                            <div className="col-sm-4 ">
                                <input
                                    name="name"
                                    type="text"
                                    value={addManufacturerForm.name}
                                    className="form-control"
                                    autoComplete="off"
                                    required={true}
                                    onChange={(e) => formInputHandler(e, "addManufacturerForm")}
                                    placeholder="Please Enter Name"
                                />
                            </div>
                        </div>
                        <div className="row align-items-center my-3">
                            <div className="col-sm-3">
                                <label htmlFor="nick_name" className="form-label">Nick Name</label>
                            </div>
                            <div className="col-sm-4 ">
                                <input
                                    name="nick_name"
                                    id="nick_name"
                                    type="text"
                                    value={addManufacturerForm.nick_name}
                                    className="form-control"
                                    autoComplete="off"
                                    required={true}
                                    onChange={(e) => formInputHandler(e, "addManufacturerForm")}
                                    placeholder="Please Enter Nick Name"
                                />
                            </div>
                        </div>
                        <div className="row align-items-center my-3">
                            <div className="col-sm-3">
                                <label htmlFor="notes" className="form-label require">Notes</label>
                            </div>
                            <div className="col-sm-4 add_calender_section">
                                <textarea
                                    name="notes"
                                    value={addManufacturerForm.notes}
                                    onChange={(e) => formInputHandler(e, 'addManufacturerForm')}
                                    className="form-control"
                                    style={{ height: "100px" }}
                                    required={true}
                                />
                            </div>
                        </div>
                    </Ax>}
                <div className="col-12 text-end fixed_footer">
                    <button type="button" disabled={saveFormSubmitting} onClick={closeEvent} className="btn btn-secondary mx-3">Cancel</button>
                    <button type="submit" disabled={saveFormSubmitting} className="btn btn-primary mx-2">
                        Save {saveFormSubmitting ? (<tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin" />) : ''}
                    </button>
                </div>
            </form>
        );
    };

    return (
        <ApplicationLayout>
            <Helmet><title>Manufacturer Add</title></Helmet>
            <div className="page_title row m0">
                <div className="col-12">
                    <h3>{editResource ? "Edit" : "Add"} Manufacturer</h3>
                    <div className="text-end mt15">
                        <button onClick={closeEvent} disabled={saveFormSubmitting} type="button" className="btn btn-secondary">
                            <tapIcon.imageIcon icon={tapIcon.CloseIcon} className="img-fluid" alt="Close Fuel Station" />
                        </button>
                    </div>
                </div>
            </div>
            <div className="container-fluid">
                <div className="page_containt row pl2">
                    <div className="pageTbl col-12 pl4">
                        {saveManufacturerFormJsx()}
                    </div>
                </div>
            </div>
        </ApplicationLayout>
    );
};


export default ManufacturerAdd;
